module.exports = __webpack_public_path__ + "img/discount.7d125040.svg";